module.exports = __webpack_public_path__ + "img/boss_text.b7c7d41a.png";